module.exports = __webpack_public_path__ + "static/media/logo.981754dc.jpg";